export default function updateAction(state, payload) {
  return {
    ...state,
    montazni: {
      ...state.montazni,
      ...payload,
    },
  };
}
